import React from 'react';
import Apiboxd from '../assets/images/New_Jul_2025/Apibox.svg';
import { MdOutlineFileDownload } from "react-icons/md";

function Apibox() {
  const handleDownload = () => {
    window.open('https://drive.google.com/file/d/1NQDbG5C4iY7uqBKfYrLOo5rplUS4FRg1/view?usp=sharing', '_blank');
  };

  return (
    <>
       <div className="flex flex-col md:flex-row h-[80vh] justify-between items-center bg-gray-50 p-10 rounded-lg shadow-md">
      <div className="mb-8 md:mb-0">
        <h2 className="text-[3.1rem] font-bold text-[#0B4445] mb-4">API BOX</h2>
        <h1 className="text-[2.1rem] md:text-4xl font-semibold mb-4">
          Manage API Access &amp; Documentation
        </h1>
        <div className="flex gap-4">
          <button className="flex items-center px-4 py-2 bg-white border border-gray-300 rounded hover:bg-gray-100">
            Download API
            <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 15V3" />
            </svg>
          </button>
           <button 
           className="flex items-center px-4 py-2 bg-white border border-gray-300 rounded hover:bg-gray-100"
              onClick={handleDownload}
            >
               API Document <MdOutlineFileDownload size={30} />
            </button>
        </div>
      </div>
      <div>
        <img
          src={Apiboxd}
          alt="API Illustration"
          className="w-[330px] md:w-[630px]"
        />
      </div>
    </div>
    </>

  );
}

export default Apibox;